var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paymentInfoLabel || _vm.paymentInfoDetail || _vm.linkLabel
    ? _c(
        "div",
        {
          staticClass: "py-0 cb-4-x-pxf-mention",
          class: { small: !_vm.isFromMobileDetail },
        },
        [
          _vm.paymentInfoLabel
            ? _c("strong", [
                _c("span", {
                  class: { "d-block": !_vm.isFromMobileDetail },
                  domProps: { innerHTML: _vm._s(_vm.paymentInfoLabel) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.paymentInfoDetail
              ? _c("div", {
                  staticClass: "col-auto text-gray3 small",
                  domProps: { innerHTML: _vm._s(_vm.paymentInfoDetail) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.linkLabel
              ? _c(
                  "div",
                  { staticClass: "col-auto pt-0 small" },
                  [
                    _c("ob1-liens-icone", {
                      attrs: {
                        icon: "icon-info-alt font-size-24",
                        "is-button": true,
                        title: _vm.linkLabel,
                        "modal-id": _vm.modalId,
                        mini: true,
                        "data-oevent-category": "popin_financement",
                        "data-oevent-action":
                          "voir_nos_solutions_de_financement",
                        "data-oevent-label": "vers_popin",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }